import { Map } from 'mapbox-gl';
import { MapActions, MapActionsTypes } from './map.actions';
import { MapFilterSize } from './map.interfaces';
import { IMapPopupPosition } from './popup';

interface MapStates {
  map: Map | null;
  currentMapId: string | undefined;
  currentMapStyle: mapboxgl.Style | null;
  showMap: boolean;
  showLoader: boolean;
  hideFilter: boolean;
  filterModalSize: MapFilterSize | null;
  popupPositon: IMapPopupPosition;
}

export const initialMapState: MapStates = {
  map: null,
  currentMapId: undefined,
  currentMapStyle: null,
  showMap: false,
  showLoader: false,
  hideFilter: false,
  filterModalSize: null,
  popupPositon: { top: 0 },
};

export const mapReducer = (state: MapStates, action: MapActions) => {
  switch (action.type) {
    case MapActionsTypes.SET_MAP:
      return { ...state, ...{ map: action.payload as Map | null } };

    case MapActionsTypes.CURRENT_MAP_ID:
      return {
        ...state,
        ...{ currentMapId: action.payload as string | undefined },
      };
    case MapActionsTypes.CURRENT_MAP_STYLE:
      return {
        ...state,
        ...{ currentMapStyle: action.payload as mapboxgl.Style | null },
      };
    case MapActionsTypes.SHOW_MAP:
      return { ...state, ...{ showMap: action.payload as boolean } };
    case MapActionsTypes.SHOW_LOADER:
      return { ...state, ...{ showLoader: action.payload as boolean } };
    case MapActionsTypes.HIDE_FILTER:
      return { ...state, ...{ hideFilter: action.payload as boolean } };
    case MapActionsTypes.SET_FILTER_MODAL_SIZE:
      return {
        ...state,
        ...{ filterModalSize: action.payload as MapFilterSize | null },
      };
    case MapActionsTypes.SET_POPUP_POSITION:
      return {
        ...state,
        ...{ popupPositon: action.payload as IMapPopupPosition },
      };
    default:
      throw new Error();
  }
};
